import styled, { type Theme } from 'styled-components'

import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { Button } from '@/ui/atoms/button'
import { Flex } from '@/ui/atoms/flex'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'
import { styleFromTypography } from '@/ui/helpers/styleFromTypography'

type QuickFiltersContainerProps = {
  isMapView: boolean
}

type QuickFiltersScrollContainerProps = {
  isSticky: boolean
  isScrollingUp: boolean
}

type QuickFilterButtonTextProps = {
  isLocationFilter?: boolean
  isRadialLocation?: boolean
}

export const QuickFilterButtonStyles = styled(Button)<{
  $hideOnDesktop?: boolean
}>(
  ({ theme, $hideOnDesktop }) => `
  min-width: 12rem;
  max-width: 18rem;
  max-height: 4rem;
  flex-shrink: 0;

  ${MEDIA_QUERIES(theme).medium} {
    ${$hideOnDesktop ? 'display: none;' : ''}
  }
`
)

export const AllFiltersButtonStyles = styled(Button)(
  ({ theme }) => `
    border-radius: ${theme.borderRadius.rounded};
    max-height: 4rem;
    position: relative;
`
)
export const QuickFilterButtonText = styled.span<QuickFilterButtonTextProps>(
  ({ theme, isLocationFilter, isRadialLocation }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  flex-grow: 1;
  font-weight: ${theme.fontWeight.regular};
  ${
    isLocationFilter &&
    !isRadialLocation &&
    `
    display: inline-block;
    max-width: 11.5ch;
  `
  }
`
)

export const QuickFiltersContainer = styled.div<QuickFiltersContainerProps>(
  ({ theme, isMapView }) => `
  background-color: ${theme.colors.white};
  box-shadow: ${theme.boxShadow['shadow-4']};
  display: ${isMapView ? 'none' : 'block'};
  margin-left: calc(-50vw + 50%);
  min-width: 100%;
  overflow-x: scroll;
  width: 100vw;

  &::-webkit-scrollbar {
    display: none;
  }

  z-index: ${zIndexRegistry.QUICK_FILTERS};

  ${MEDIA_QUERIES(theme).medium}{
    box-shadow: none;
    display: block;
    margin-left: 0;
    overflow-x: unset;
    top: 0;
    width: 100%;
  }
`
)

export const QuickFiltersSpacing = styled.div(
  ({ theme }) => `
    padding-top: 0;

    ${MEDIA_QUERIES(theme).medium}{
      padding-top: ${theme.spacing.default};
    }
  `
)

export const quickFiltersScrollContainer_original = (theme: Theme) => `
  margin: 0 ${theme.spacing.default};

  ${MEDIA_QUERIES(theme).medium}{
    margin-left: 0;
    top: 0;
  }
`

export const QuickFiltersScrollContainer = styled(Flex)<QuickFiltersScrollContainerProps>(
  ({ theme, isSticky, isScrollingUp }) => `
  ${isSticky && `box-shadow: ${theme.boxShadow['shadow-4']};`}
  ${isSticky && `position: fixed;`}

  background-color: ${theme.colors.white};
  left: 0;
  margin-left: 0;
  margin: 0;
  max-width: 100%;
  padding: ${theme.spacing.default} 0 ${theme.spacing.default} ${theme.spacing.default};
  top: ${isScrollingUp ? '7.6rem' : '0'};
  transition: top 0.3s ease-in-out;
  width: 100vw;

  &::-webkit-scrollbar {
    display: none;
  }

  ${MEDIA_QUERIES(theme).medium}{
    ${!isSticky && 'padding-top: 0;'}
    padding-left: 0;
    top: 0;
  }
`
)

export const QuickFiltersWrapper = styled(Flex)<{ isSticky?: boolean; isMapView: boolean }>(({
  theme,
  isSticky,
  isMapView,
}) => {
  return `
  ${
    isSticky
      ? `
      ${MEDIA_QUERIES(theme).large}{
        max-width: 144rem;
        width: 100%;
      }
      ${MEDIA_QUERIES(theme).xLarge}{
        padding: 0 5.8rem;
        ${!isMapView ? 'margin: 0 auto' : ''};
      }
    `
      : ``
  }
`
})

const filterCountSize = '2.5rem'

export const FilterCountBadge = styled(Flex)(
  ({ theme }) => `
  height: ${filterCountSize};
  width: ${filterCountSize};
  border-radius: ${theme.borderRadius.rounded};
  background-color: ${theme.colors.grey.light5};
  color: ${theme.colors.purple.primary};
  border: 0.2rem solid ${theme.colors.purple.primary};
  position: absolute;
  top: -0.9rem;
  right: -0.9rem;
  ${styleFromTypography(theme.typography.body.xSmall)}
`
)

export const LocationIconContainer = styled.div`
  align-items: center;
  display: flex;

  & svg {
    height: 1.6rem;
    width: 1.6rem;
  }
`
